import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-094739c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calculator" }
const _hoisted_2 = { class: "mt-3 flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "grid grid-cols-2 gap-3 mt-6"
}
const _hoisted_5 = {
  key: 0,
  class: "grid grid-cols-1 mt-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_calculator_tabs = _resolveComponent("calculator-tabs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_calculator_form = _resolveComponent("calculator-form")!
  const _component_calculator_result = _resolveComponent("calculator-result")!
  const _component_calculator_form_ftl = _resolveComponent("calculator-form-ftl")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_calculator_tabs, {
      value: _ctx.state.currentTab,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.currentTab) = $event))
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Расчет стоимости" }),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/')))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    (_ctx.isLtl)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_calculator_form, {
            loading: _ctx.state.is_loading,
            onSubmit: _ctx.onFormSubmit
          }, null, 8, ["loading", "onSubmit"]),
          (_ctx.state.is_form_submited)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_calculator_result, {
                  loading: _ctx.state.is_loading,
                  "from-city-name": _ctx.state.from_city_name,
                  "where-city-name": _ctx.state.where_city_name,
                  "is-has-pickup": _ctx.state.is_has_pickup,
                  "is-has-self-delivery": _ctx.state.is_has_self_delivery,
                  cost: _ctx.state.econom.result,
                  days: _ctx.state.econom.days,
                  "insurance-cost": _ctx.state.econom.insuranceCost,
                  "unload-cost": _ctx.state.econom.unloadCost,
                  "packaging-cost": _ctx.state.econom.packagingCost,
                  "tariff-id": _ctx.state.tariff_id,
                  "used-weight-in-kg": _ctx.state.econom.usedWeightInKg,
                  "weight-type-to-calculate": _ctx.state.econom.weightTypeToCalculate,
                  "additional-service-delivery": _ctx.state.econom.additionalServiceDelivery,
                  "additional-service-take": _ctx.state.econom.additionalServiceTake,
                  "shipment-type-id": 1,
                  "declared-price": _ctx.state.declaredPrice,
                  "product-name": _ctx.state.productName,
                  "delivery-charge": _ctx.state.econom.deliveryCharge,
                  "final-cost": _ctx.state.econom.result
                }, null, 8, ["loading", "from-city-name", "where-city-name", "is-has-pickup", "is-has-self-delivery", "cost", "days", "insurance-cost", "unload-cost", "packaging-cost", "tariff-id", "used-weight-in-kg", "weight-type-to-calculate", "additional-service-delivery", "additional-service-take", "declared-price", "product-name", "delivery-charge", "final-cost"]),
                _createVNode(_component_calculator_result, {
                  loading: _ctx.state.is_loading,
                  "from-city-name": _ctx.state.from_city_name,
                  "where-city-name": _ctx.state.where_city_name,
                  "is-has-pickup": _ctx.state.is_has_pickup,
                  "is-has-self-delivery": _ctx.state.is_has_self_delivery,
                  cost: _ctx.state.express.result,
                  days: _ctx.state.express.days,
                  "insurance-cost": _ctx.state.express.insuranceCost,
                  "unload-cost": _ctx.state.express.unloadCost,
                  "packaging-cost": _ctx.state.express.packagingCost,
                  "tariff-id": _ctx.state.tariff_id,
                  "used-weight-in-kg": _ctx.state.express.usedWeightInKg,
                  "weight-type-to-calculate": _ctx.state.express.weightTypeToCalculate,
                  "additional-service-delivery": _ctx.state.express.additionalServiceDelivery,
                  "additional-service-take": _ctx.state.express.additionalServiceTake,
                  "shipment-type-id": 2,
                  "is-cities-equals": _ctx.state.is_cities_equals,
                  "declared-price": _ctx.state.declaredPrice,
                  "product-name": _ctx.state.productName,
                  "delivery-charge": _ctx.state.express.deliveryCharge,
                  "final-cost": _ctx.state.express.result
                }, null, 8, ["loading", "from-city-name", "where-city-name", "is-has-pickup", "is-has-self-delivery", "cost", "days", "insurance-cost", "unload-cost", "packaging-cost", "tariff-id", "used-weight-in-kg", "weight-type-to-calculate", "additional-service-delivery", "additional-service-take", "is-cities-equals", "declared-price", "product-name", "delivery-charge", "final-cost"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isFtl)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_calculator_form_ftl, {
            loading: _ctx.state_ftl.is_loading,
            onSubmit: _ctx.onFormFtlSubmit
          }, null, 8, ["loading", "onSubmit"]),
          (_ctx.state_ftl.is_form_submited)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_calculator_result, {
                  loading: _ctx.state_ftl.is_loading,
                  "from-city-name": _ctx.state_ftl.from_city_name,
                  "where-city-name": _ctx.state_ftl.where_city_name,
                  "final-cost": _ctx.state_ftl.econom.finalCost,
                  "delivery-cost": _ctx.state_ftl.econom.deliveryCost,
                  "downtime-cost": _ctx.state_ftl.econom.downtimeCost,
                  "vat-coefficient": _ctx.state_ftl.econom.vatCoefficient,
                  "additional-service-delivery": _ctx.state_ftl.econom.additionalServiceDelivery,
                  "additional-service-take": _ctx.state_ftl.econom.additionalServiceTake,
                  "shipment-type-id": 1,
                  "is-ftl": ""
                }, null, 8, ["loading", "from-city-name", "where-city-name", "final-cost", "delivery-cost", "downtime-cost", "vat-coefficient", "additional-service-delivery", "additional-service-take"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}